var resources = require('items-view-strings');
    var strings = resources['_uf+QKHV7Q4uYCMleLifz+g'];
export { strings };
export default strings;
